<template>
  <div class="site-container site-section-v">
    <form-report>
      <template #form-top>
        <h2 class="text-orange" style="margin-bottom: 3rem">
          Canal de Denúncia
        </h2>
        <p>
          O Escritório, em seu firme propósito de zelar pela ética, transparência e integridade em todas as esferas de atuação, disponibiliza este canal de denúncia.
        </p>
        <p>Assim, este é um canal exclusivo para comunicação de desvios de conduta ética (não condizentes com os valores do escritório) ou que violem a legislação vigente.</p>
        <p>Ressaltamos que este é um meio de comunicação seguro e, se desejado, anônimo.  Para tanto, é garantido o sigilo absoluto e a confidencialidade das informações, pois reconhecemos a importância de um ambiente propício para que as denúncias sejam feitas com confiança.</p>
        <p>A apuração das denúncias será conduzida com total imparcialidade e medidas disciplinares serão aplicadas em caso de infração.</p>
      </template>
    </form-report>
  </div>
</template>

<script>
import FormReport from "@/components/FormReport.vue";

export default {
  components: { FormReport },

};
</script>

<style>
</style>
